import { render } from "./ListPartnersView.vue?vue&type=template&id=8a066bc6"
import script from "./ListPartnersView.vue?vue&type=script&lang=js"
export * from "./ListPartnersView.vue?vue&type=script&lang=js"

import "./ListPartnersView.vue?vue&type=style&index=0&id=8a066bc6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__